import { A } from '@adornis/base/env-info';
import { Int } from '@adornis/baseql/baseqlTypes';
import { Arg, Entity, Field, Query } from '@adornis/baseql/decorators';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity';
import needle from 'needle';
import { join } from 'path';
import { NodeBBTag } from './nodebb-tag';

const NODEBB_API_URL = A.isServer ? process.env.NODEBB_API_URL : undefined;
if (A.isServer && !NODEBB_API_URL) throw new Error('Please define NODEBB_API_URL');

@Entity()
export class NodeBBPostUser extends AdornisEntity {
  static _class = 'NodeBBPostUser';
  @Field(type => Int)
  uid!: number;
  @Field(type => String)
  username!: string;
  @Field(type => String)
  displayname!: string;
  @Field(type => String)
  userslug!: string;
  @Field(type => String)
  picture!: string;
  @Field(type => String)
  status!: string;
}

@Entity()
export class NodeBBPostTopic extends AdornisEntity {
  static _class = 'NodeBBPostTopic';
  @Field(type => Int)
  uid!: number;
  @Field(type => Int)
  tid!: number;
  @Field(type => String)
  title!: string;
  @Field(type => Int)
  cid!: number;
  @Field(type => String)
  slug!: string;
  @Field(type => Int)
  deleted!: number;
  @Field(type => Int)
  scheduled!: number;
  @Field(type => Date)
  timestamp!: Date;
  @Field(type => String)
  timestampISO!: string;
  @Field(type => Int)
  postcount!: number;
  @Field(type => Int)
  mainPid!: number;
  @Field(type => Int)
  teaserPid!: number;
  @Field(type => String)
  titleRaw!: string;
  @Field(type => String)
  oldTitle!: string;
  @Field(type => Boolean)
  isMainPost!: boolean;
  @Field(type => Boolean)
  renamed!: boolean;
  @Field(type => [NodeBBTag])
  tags!: NodeBBTag[];
}

@Entity()
export class NodeBBPostCategory extends AdornisEntity {
  static _class = 'NodeBBPostCategory';
  @Field(type => Int)
  cid!: number;
  @Field(type => String)
  name!: string;
  @Field(type => String)
  icon!: string;
  @Field(type => String)
  slug!: string;
  @Field(type => Int)
  parentCid!: number;
  @Field(type => String)
  color!: string;
  @Field(type => String)
  bgColor!: string;
}

@Entity()
export class NodeBBPost extends AdornisEntity {
  static _class = 'NodeBBPost';

  @Field(type => Int)
  pid!: number;
  @Field(type => Int)
  tid!: number;
  @Field(type => String)
  content!: string;
  @Field(type => Int)
  uid!: number;
  @Field(type => Date)
  timestamp!: Date;
  @Field(type => Boolean)
  deleted!: boolean;
  @Field(type => Int)
  upvotes!: number;
  @Field(type => Int)
  downvotes!: number;
  @Field(type => Int)
  votes!: number;
  @Field(type => String)
  timestampISO!: string;
  @Field(type => NodeBBPostUser)
  user!: NodeBBPostUser;
  @Field(type => NodeBBPostTopic)
  topic!: NodeBBPostTopic;
  @Field(type => NodeBBPostCategory)
  category!: NodeBBPostCategory;
  @Field(type => Boolean)
  isMainPost!: boolean;
  @Field(type => Int)
  replies!: number;

  @Query(type => [NodeBBPost])
  static getRecentNodeBBPosts(@Arg('term', type => String) term: 'day' | 'week' | 'month' | '' = '') {
    return async (gqlFields: string) => {
      const url = new URL(join('/api/recent/posts', term), NODEBB_API_URL!).href;
      const response = await needle('get', url);
      const body = response.body;
      if (!Array.isArray(body)) throw new Error(body);
      return body.map(item => new this(item));
    };
  }
}
